import React from "react";
import { theme } from "src/utils/theme";
import styled from "styled-components";

export const BetaTag: React.FC = () => {
  return <Container>Beta</Container>;
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 37px;
  height: 20px;

  padding: 4px 8px;

  color: ${theme.text.brand.primary};
  font-size: 8px;
  font-weight: 600;
  line-height: 12px;
  text-transform: uppercase;

  border-radius: 4px;
  background-color: ${theme.fill.brand.secondary};
`;
